import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  useAllPromosQuery,
  useCreatePromoMutation,
  useDeletePromoMutation,
  useUpdatePromoMutation,
  useGetPromoActivationsQuery,
} from '../../../store/api/promo.api';
import styles from './PromoAdminPage.module.css';
import { PromoModal } from '../Modal/PromoModal/PromoModal';

const PromoRow = ({ promo, onEdit, onDelete }) => {
  const { data, isLoading } = useGetPromoActivationsQuery(promo.id);

  return (
    <div className={styles.row}>
      <div>{promo.id}</div>
      <div>{promo.code}</div>
      <div>{promo.disc}%</div>
      <div>{promo.endDate ? promo.endDate.slice(0, 10) : '—'}</div>
      <div>{isLoading ? '...' : data?.activations ?? 0}</div>
      <div className={styles.actionsInline}>
        <span onClick={() => onEdit(promo)} className={styles.actionText}>Редактировать</span>
        <span onClick={() => onDelete(promo.id)} className={styles.actionText}>Удалить</span>
      </div>
    </div>
  );
};

export const PromoAdminPage = () => {
  const navigate = useNavigate();
  const { data: promos = [], isLoading, refetch } = useAllPromosQuery();
  const [createMode, setCreateMode] = useState(false);
  const [editPromo, setEditPromo] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);

  const PROMOS_PER_PAGE = 20;

  const [createPromo] = useCreatePromoMutation();
  const [updatePromo] = useUpdatePromoMutation();
  const [deletePromo] = useDeletePromoMutation();

  const handleCloseModal = () => {
    setCreateMode(false);
    setEditPromo(null);
  };

  const handlePromoSubmit = async (promoData) => {
    try {
      if (editPromo) {
        await updatePromo({ id: editPromo.id, ...promoData }).unwrap();
      } else {
        await createPromo(promoData).unwrap();
      }
      refetch();
    } catch (error) {
      alert('Ошибка при сохранении промокода');
    }
    handleCloseModal();
  };

  const handleDelete = async (id) => {
    if (window.confirm('Удалить промокод?')) {
      try {
        await deletePromo(id).unwrap();
        refetch();
      } catch (error) {
        alert('Ошибка при удалении промокода');
      }
    }
  };

  const filteredPromos = promos.filter(p =>
    p?.code?.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const totalPages = Math.ceil(filteredPromos.length / PROMOS_PER_PAGE);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) setCurrentPage(page);
  };

  const promosToShow = filteredPromos.slice(
    (currentPage - 1) * PROMOS_PER_PAGE,
    currentPage * PROMOS_PER_PAGE
  );

  if (isLoading) return <div className={styles.loading}>Загрузка...</div>;

  return (
    <div className={styles.main}>
      <div className={styles.backWrapper}>
        <button className={styles.backButton} onClick={() => navigate('/admin')}>
          ← Назад
        </button>
      </div>

      <h2 className={styles.title}>Промокоды</h2>

      <div className={styles.buttonWrapper}>
        <button className={styles.addButton} onClick={() => setCreateMode(true)}>
          Добавить промокод
        </button>
      </div>

      <div className={styles.searchWrapper}>
        <input
          type="text"
          value={searchQuery}
          onChange={(e) => {
            setSearchQuery(e.target.value);
            setCurrentPage(1);
          }}
          placeholder="Поиск по коду..."
          className={styles.searchInput}
        />
      </div>

      <div className={styles.header}>
        <div>ID</div>
        <div>Код</div>
        <div>Скидка</div>
        <div>Дата окончания</div>
        <div>Активации</div>
        <div></div> {/* действия */}
      </div>

      <div className={styles.list}>
        {promosToShow.map((promo) => (
          <PromoRow
            key={promo.id}
            promo={promo}
            onEdit={setEditPromo}
            onDelete={handleDelete}
          />
        ))}
      </div>

      {totalPages > 1 && (
        <div className={styles.pagination}>
          <button
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
            className={styles.pageButton}
          >
            Назад
          </button>
          <span className={styles.pageInfo}>
            Страница {currentPage} из {totalPages}
          </span>
          <button
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            className={styles.pageButton}
          >
            Вперёд
          </button>
        </div>
      )}

      {(createMode || editPromo) && (
        <PromoModal
          isOpen={createMode || !!editPromo}
          onClose={handleCloseModal}
          onSubmit={handlePromoSubmit}
          initialData={editPromo}
        />
      )}
    </div>
  );
};
